import { render, staticRenderFns } from "./TransactionRefunds.vue?vue&type=template&id=12020576&"
import script from "./TransactionRefunds.vue?vue&type=script&lang=js&"
export * from "./TransactionRefunds.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRefunds.vue?vue&type=style&index=0&id=12020576&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports